import Page from './layouts/Page';
import './styles/static-site.scss';

const HowItWorks = () => {
  return (
    <Page>
      <h1>How it Works</h1>
      <p>
        No matter where your business is located, we have a team ready to introduce you to our event and meeting management software that will help
        you connect better. At Stargid, we are always on the look out for new talent who are passionate about what they do, the industry and bringing
        that enthusiasm to our team. View our open opportunities and join a company that is dedicated to helping clients connect better!
      </p>

      <h6>Platform Overview</h6>
      <p>
        Make every impression count at conferences, meetings and beyond. Discover the powerful Stargid Platform. Create a seamless event experience
        from beginning to end with our bespoke onsite solutions. Explore the Stargid Onsite Experience Lead Retrieval Check-in &amp; Badging Session
        Tracking &amp; Access Control.
      </p>

      <h6>Event Management Software</h6>
      <p>
        Our event management system helps you simplify event planning. It has the power and flexibility global enterprises need and the scalability
        that event organizers love. If you need any special software for your events please don’t hasitate to contact our sales team. The Stargid
        event Management software comes as an ios / Android &amp; web-application. The Event Manager Registration normaly takes place in the
        web-application, where he can manage, upload and have an overview over all his events and the user will be able to view the event entries made
        by the event manager earlier on the web-application on his mobile device.
      </p>

      <h6>Event Manager Registration</h6>
      <p>
        Registration is the heart of our Event Management Platform. Our Event Registration product allows you to create beautiful mobile-responsive
        registration that fully align with your brand and resonate with your attendees, exhibitors and sponsors. It offers powerful and flexible event
        reporting, all while complying with the highest security and privacy standards. Ready to see our Event Management Platform in action? Schedule
        a meeting with one of our members or just try it yourself and Register today.
      </p>

      <h6>Stargid Event App</h6>
      <p>
        Stargids state-of-the-art event app enables the event planner to keep their clients informed at all times. The extensive set of networking
        features enables clients to use the mobile event app to connect with their peers and helps planners understand what they value the most.
        Stargid's Mobile Event App is a feature-packed digital event booking, driving Event managers engagement and providing real-time event sales
        insights. With its unique blend of information, engagement and interaction features, it's the best event app available.
      </p>

      <h6>Marketing Technology</h6>
      <p>
        Connect with your target audience at the right time. The event Marketing enables planners to market their event and run effective campaigns to
        promote their events.
      </p>

      <h6>Mobile Event booking over the App</h6>
      <p>
        Our Strategic Sourcing Solution simplifies the process of booking venues and delivers visibility into total bookings made. It manages the many
        details associated to mobile bookings into bringing the clients and event managers under one roof.
      </p>

      <h6>Easy Venue Search</h6>
      <p>Filters out venues according to distance , price, ratings and more. </p>

      <h6>Never lose a customer again</h6>
      <p>
        Stop chasing down after customers for your events. Now with the help of Startgid App, we ensures complete booking of your events online
        anytime and ensure your booking within seconds.
      </p>

      <h6> Track bookings</h6>
      <p>Manage your bookings in one place. Track your event online without personally being on the location.</p>

      <h6>Get rated</h6>
      <p>Clients can mark favorite venues and share experiences, both good and bad. See venues booked company-wide to leverage negotiations. </p>

      <h6>Payment</h6>
      <p>
        The payment is very simple. Stripe is used as a payment method for our platform. As soon as a particular event is selected and the necessary
        commission fee is made, you will get a notification for your booking and that’s it! Tada your booking is made!!!
      </p>

      <h6>Platform Technology</h6>
      <p>
        The technology used in the platform is very modern and useful, specially when it comes to quick reactions and performance. We have used the
        most modern software in the Application for the better performance and to make it user friendly to the customers &amp;amp clients. The most
        advanced technology used in most modern apps such as facebook, instagram and airbnb
      </p>
    </Page>
  );
};

export default HowItWorks;
